import { ZonedDateTime } from '@internationalized/date';
import {
  ContainerSortOption as ContainerSortOptionSchema,
  ContainerStatus as ContainerStatusSchema,
  enumContainerSortOption as enumContainerSortOptionSchema,
  enumContainerStatus as enumContainerStatusSchema,
} from '@rematter/frontend-lib-api-client';

export type ContainerSortOption = ContainerSortOptionSchema;
export type ContainerStatus = ContainerStatusSchema;
export const enumContainerSortOption = enumContainerSortOptionSchema;
export const enumContainerStatus = enumContainerStatusSchema;

export type ContainerRecord = {
  id: string;
  containerNumber: string | null;
  sealNumber: string | null;
  status: ContainerStatus;

  // Relationships
  bookingId: string;
  booking?: {
    id: string;
    bookingNumber: string;
  } | null;
  containerTypeId: string;
  containerType?: {
    id: string;
    name: string;
  } | null;
  loadId: string | null;
  load?: {
    id: string;
    documentNumber: string;
  } | null;
  facilityId: string | null;
  facility?: {
    id: string;
    facilityName: string;
  } | null;

  // State transition timestamps
  pickedUpAt?: ZonedDateTime;
  arrivedAtFacilityAt?: ZonedDateTime;
  loadedAt?: ZonedDateTime;
  departedFacilityAt?: ZonedDateTime;
  returnedToPortAt?: ZonedDateTime;
  shippedAt?: ZonedDateTime;

  // Audit fields
  organizationId: string;
  createdBy: string;
  createdByUser?: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;
  updatedBy: string;
  updatedByUser?: {
    id: string;
    firstName: string;
    lastName: string;
  } | null;

  // Timestamps
  timestamps: {
    createdAt: ZonedDateTime;
    updatedAt: ZonedDateTime;
  };
};

export type ContainerStatusCounts = {
  atPort: number;
  inTransitToFacility: number;
  atFacilityEmpty: number;
  atFacilityLoaded: number;
  inTransitToPort: number;
  atPortReadyToShip: number;
  shipped: number;
  voided: number;
  total: number;
};

export type ContainerDetailsTab = 'overview' | 'timeline';

export type ContainerTransitionAction =
  | 'pickup'
  | 'arriveAtFacility'
  | 'load'
  | 'departFacility'
  | 'returnToPort'
  | 'ship';

export const enumContainerTransitionAction = {
  Pickup: 'pickup' as const,
  ArriveAtFacility: 'arriveAtFacility' as const,
  Load: 'load' as const,
  DepartFacility: 'departFacility' as const,
  ReturnToPort: 'returnToPort' as const,
  Ship: 'ship' as const,
};

export type ContainerFormState = {
  id?: string;
  containerNumber?: string | null;
  sealNumber?: string | null;
  status: ContainerStatus;
};
